export default "__VITE_ASSET__D5itQVBt__"